
  import gql from 'graphql-tag';
  import moment from 'moment';
  import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
  import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
  import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
  import travelTooltips from '~/apollo/queries/product/tooltips/travelTooltips';
  import commonProductMixins from '~/mixins/commonProductMixins.js';
  import productPromotionMixins from '~/mixins/productPromotionMixins.js';
  import travelRegionsQuery from '@/apollo/queries/product/travelRegions'
  import travelScenariosQuery from '@/apollo/queries/product/travelScenarios'
  import productShortcutMixins from "~/mixins/productShortcutMixins.js";
  import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
  import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

  import travelGeoRegionsQuery from '@/apollo/queries/product/travelGeoRegions'
  import alTrScenarios from '@/apollo/queries/product/annualTravelScenarios'

  export default {
    name: 'ProductTravelListingPage',
    mixins: [commonProductMixins, productPromotionMixins, productShortcutMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

    apollo: {
      $loadingKey: 'loading',
      travelScenarios: {
        query: gql`
          ${travelScenariosQuery}
          ${productPromotionFragment}
        `,
        prefetch: true,
        variables() {
          let tmpComp;
          tmpComp = undefined;

          let tmpGeoRegion;
          if (this.filter.geoRegionValue.length > 0) {
            tmpGeoRegion = this.filter.geoRegionValue?.map(geo => geo.value) || undefined;
          } else {
            tmpGeoRegion = undefined;
          }

          let tmpLocale;
          tmpLocale = undefined;

          if (this.currentLocale) {
            tmpLocale = this.currentLocale;
          }

          if (this.filter.insCompValue?.length) {
            // console.log(this.filter.insCompValue, 'ins')
            tmpComp = this.filter.insCompValue.map((x) => x.value);
            // console.log(tmpComp)
          }

          let tmpSelectedCustomer = this.filter.selectedCustomer === 'true' || this.filter.selectedCustomer === true ? false : undefined;

          let tmpTenlifeScore = this.filter.tenlifeScoreValue.value === 'any' ? undefined : parseFloat(this.filter.tenlifeScoreValue.value);

          // let tmpMobile = false;
          // let tmpPhysio = false;
          // let tmpCar = false;
          // let tmpExtreme = false;
          // let tmpTravel = false;
          // let tmpAny = false;

          const returnObj = {
            insCompCode: tmpComp,
            locale: tmpLocale,
            region_code: tmpGeoRegion,
            max_issue_age: parseInt(this.filter.maxIssueAgeValue?.value),
            selected_customer: tmpSelectedCustomer,
            tenlife_score: tmpTenlifeScore
            // geo_code: tmpGeoCode
            // follow_up_physiotherapy: tmpPhysio,
            // car_rental_excess: tmpCar,
            // extreme_sports_medical: tmpExtreme,
            // loss_of_travel_document: tmpTravel,
          };
          // if (this.filter.geoRegionValue.length > 0) {
          //   returnObj.region_code = tmpGeoRegion;
          // }
          for (const feature of this.filter.featureTypeValue) {
            switch (feature.value) {
              case "1":
              returnObj.mobile_phone_protection = true;
                break;
              case "2":
                returnObj.follow_up_physiotherapy = true;
                break;
              case "3":
                returnObj.car_rental_excess = true;
                break;
              case "4":
                returnObj.extreme_sports_medical = true;
                break;
              case "5":
                returnObj.loss_of_travel_document = true;
                break;
            }
          }
          return returnObj;
        },
        skip() {
          return this.planTypeIsAnnual;
        }
      },
      alTrScenarios: {
        query: gql`
          ${alTrScenarios}
          ${productPromotionFragment}
        `,
        prefetch: true,
        variables() {
          let tmpComp;
          tmpComp = undefined;

          let tmpContinentRegion;
          if (this.filter.travelContinentValue?.value) {
            tmpContinentRegion = this.filter.travelContinentValue?.value || undefined;
          } else {
            tmpContinentRegion = undefined;
          }

          let tmpLocale;
          tmpLocale = undefined;

          if (this.currentLocale) {
            tmpLocale = this.currentLocale;
          }

          if (this.filter.insCompValue?.length) {
            // console.log(this.filter.insCompValue, 'ins')
            tmpComp = this.filter.insCompValue.map((x) => x.value);
            // console.log(tmpComp)
          }

          let tmpSelectedCustomer = this.filter.selectedCustomer === 'true' || this.filter.selectedCustomer === true ? false : undefined;

          let tmpTenlifeScore = this.filter.tenlifeScoreValue.value === 'any' ? undefined : parseFloat(this.filter.tenlifeScoreValue.value);

          // let tmpMobile = false;
          // let tmpPhysio = false;
          // let tmpCar = false;
          // let tmpExtreme = false;
          // let tmpTravel = false;
          // let tmpAny = false;
          const returnObj = {
            insCompCode: tmpComp,
            locale: tmpLocale,
            geo_code: tmpContinentRegion,
            max_issue_age: parseInt(this.filter.maxIssueAgeValue?.value),
            selected_customer: tmpSelectedCustomer,
            tenlife_score: tmpTenlifeScore
            // geo_code: tmpGeoCode
            // follow_up_physiotherapy: tmpPhysio,
            // car_rental_excess: tmpCar,
            // extreme_sports_medical: tmpExtreme,
            // loss_of_travel_document: tmpTravel,
          };
          // if (this.filter.geoRegionValue.length > 0) {
          //   returnObj.region_code = tmpGeoRegion;
          // }
          for (const feature of this.filter.featureTypeValue) {
            switch (feature.value) {
              case "1":
              returnObj.mobile_phone_protection = true;
                break;
              case "2":
                returnObj.follow_up_physiotherapy = true;
                break;
              case "3":
                returnObj.car_rental_excess = true;
                break;
              case "4":
                returnObj.extreme_sports_medical = true;
                break;
              case "5":
                returnObj.loss_of_travel_document = true;
                break;
            }
          }
          return returnObj;
        },
        skip() {
          return !this.planTypeIsAnnual;
        }
      },
      insuranceCompanies: {
        query: insuranceCompaniesQuery,
        prefetch: true,
        variables() {
          return {
            show_travel: true,
          };
        },
        update(data) {
          return data.insuranceCompanies.data.map((item) => {
            const translations = item.attributes.insurance_company_translations.data;
            // console.debug(translations);
            const filteredTranslations = this.getFilteredTranslations(translations);
            return {
              value: item.attributes.code,
              text:
                filteredTranslations[0].attributes.name +
                ' | ' +
                filteredTranslations[1].attributes.name,
            };
          });
        },
      },
      travelRegions: {
        query: travelRegionsQuery,
        prefetch: true,
        update(data) {
          const GeoRegions = [{ value: '-1', text: this.$t('products.any') }];
          const tmpRegion = data.travelRegions?.data.map((item) => {
            return {
              value: item.attributes.travel_region_translations.data[0].attributes.code,
              text: item.attributes.travel_region_translations.data[this.currentLocale === 'en' ? 0 : 1].attributes.description + ' / ' + item.attributes.travel_region_translations.data[this.currentLocale === 'en' ? 1 : 0].attributes.description,
              sorting: item.attributes.sort_order,
              continent: item.attributes.continent,
            }
          })
          return tmpRegion ?
            tmpRegion.sort((a ,b) => {

              if (a.sorting === b.sorting) {
                return 0;
              }

              if (a.sorting === null) {
                return 1;
              }

              if (b.sorting === null) {
                return -1;
              }

              return a.sorting < b.sorting ? -1 : 1
            }) : GeoRegions
        }
      },
      travelTooltips: {
        query: travelTooltips,
        prefetch: true,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.infoTooltip.data);
        },
      },
      // travelContinent: {
      //   query: travelGeoRegionsQuery,
      //   prefetch: true,
      //   update(data) {
      //     const regions = this.$normalizeStrapi(data.travelGeoRegions);
      //     // Always return an array
      //     return Array.isArray(regions) ? regions : [];
      //   },
      // }
      travelContinent: {
        query: travelGeoRegionsQuery,
        prefetch: true,
        update(data) {
          const regions = this.$normalizeStrapi(data.travelGeoRegions);
          if (!Array.isArray(regions)) return [];
          // Only keep WW or ASIA
          const filtered = regions.filter(region => region.code === 'WW' || region.code === 'ASIA');
          return filtered.map(region => {
            const translations = region.travel_geo_region_translations;
            // Use currentLocale to pick translation, fallback to first
            let idx = this.currentLocale === 'en' ? 1 : 0;
            let translation = translations[idx] || translations[0];
            return {
              value: translation.code,
              text: translation.description
            };
          });
        },
      }
    },
    data() {
      return {
        loading: 0,
        currentLocale: this.$normalizeLocale(this.$i18n.locale),
        selectionSelected: false,
        filterModalOpen: false,
        activeFilter: null,
        geoRegionWatchers: null, // Store watcher references

        // Centralized filter configurations for easy management
        // To add a new filter that needs reset/sync functionality:
        // 1. Add configuration here
        // 2. Add to filterConfigs array in resetFilters method
        // 3. Add to initialSyncConfigs array in mounted method (if needed)
        filterConfigs: {
          geoRegion: {
            path: 'filter.geoRegionValue',
            defaultValue: [{
              value: 'japan',
              textKey: 'products.travel.td_default_geo',
              continent: "Asia"
            }],
            optionsPath: 'travelRegions',
            queryKey: 'geo',
            syncMethod: null
          },
          travelContinent: {
            path: 'filter.travelContinentValue',
            defaultValue: 'WW',
            queryKey: 'continent',
            defaultTextKey: 'products.travel.continent.default_value',
            optionsPath: 'travelContinent',
            syncMethod: 'syncTravelContinentValue'
          }
          // Example of adding a new filter:
          // newFilter: {
          //   path: 'filter.newFilterValue',
          //   defaultValue: 'default',
          //   queryKey: 'new_filter',
          //   defaultTextKey: 'products.travel.new_filter.default',
          //   optionsPath: 'newFilterOptions',
          //   syncMethod: 'syncNewFilterValue' // or null for generic sync
          // }
        },

        filter: {
          insCompValue: [],
          datePeriod: {
            value: [],
            range: 5,
            availableDays: 31,
          },
          geoRegionValue: [{
            value: this.$route.query.geo ? this.$route.query.geo : 'japan',
            text: this.$t("products.travel.td_default_geo"),
            continent: "Asia"
          }],

          adultPremiumValue: {
            value: [
              this.$route.query.adult_premium_from ? parseInt(this.$route.query.adult_premium_from) : 0,
              this.$route.query.adult_premium_to ? parseInt(this.$route.query.adult_premium_to) : 1500,
            ],
            text: this.$t('products.travel.td_adult_premium'),
          },
          adultPremiumOptions: [
            {
              value: [
                this.$route.query.adult_premium_from ? parseInt(this.$route.query.adult_premium_from) : 0,
                this.$route.query.adult_premium_to ? parseInt(this.$route.query.adult_premium_to) : 1500,
              ],
              text: this.$t('products.travel.td_adult_premium'),
              label: {'min': this.$t('products.priceMin'), 'max': this.$t('products.priceMax')}
            },
          ],
          adultPremiumSliderRange: [0, 1500],
          adultPremiumSliderStep: 50,

          featureTypeValue: [],
          featureTypeOptions: [
            {
                value: '1',
                text: this.$t('products.travel.td_mobile_protection')
            },
            {
                value: '2',
                text: this.$t('products.travel.td_physio')
            },
            {
                value: '3',
                text: this.$t('products.travel.td_car_rental')
            },
            {
                value: '4',
                text: this.$t('products.travel.td_extreme_sports')
            },
            {
                value: '5',
                text: this.$t('products.travel.td_loss_travel_doc')
            }
          ],

          planTypeValue: {
            value: this.$route.query.type ? this.$route.query.type : 'single',
            text: this.$t('products.travel.plan_type.single')
          },
          planTypeOptions: [
            {
              value: 'single',
              text: this.$t('products.travel.plan_type.single'),
              link: '/products/travel?type=single'
            },
            {
              value: 'annual',
              text: this.$t('products.travel.plan_type.annual'),
              link: '/products/travel?type=annual'
            }
          ],

          travelContinentValue: {
            value: this.$route.query?.continent ? this.$route.query?.continent : 'WW',
            text: this.$t("products.travel.continent.default_value"),
          },

          annualPremiumValue: {
            value: [
              this.$route.query.annual_premium_from ? parseInt(this.$route.query.annual_premium_from) : 0,
              this.$route.query.annual_premium_to ? parseInt(this.$route.query.annual_premium_to) : 5000,
            ],
            text: this.$t('products.travel.td_annual_premium'),
          },
          annualPremiumOptions: [
            {
              value: [
                this.$route.query.annual_premium_from ? parseInt(this.$route.query.annual_premium_from) : 0,
                this.$route.query.annual_premium_to ? parseInt(this.$route.query.annual_premium_to) : 5000,
              ],
              text: this.$t('products.travel.td_annual_premium'),
              label: {'min': this.$t('products.priceMin'), 'max': this.$t('products.priceMax')}
            },
          ],
          annualPremiumSliderRange: [0, 5000],
          annualPremiumSliderStep: 50,
          selectedCustomer: this.$route.query?.selected_customer === 'true' || this.$route.query?.selected_customer === true,

          maxIssueAgeValue: {
            value: this.$route.query?.max_issue_age ? this.$route.query?.max_issue_age : '65',
            text: this.$t("products.travel.max_issue_age.within", {age: '65'} ),
          },

          maxIssueAgeOptions: [
            { value: '65', text: this.$t("products.travel.max_issue_age.within", { age: '65' }) },
            { value: '70', text: this.$t("products.travel.max_issue_age.fromTo", { ageFrom: '66', ageTo: '70' }) },
            { value: '75', text: this.$t("products.travel.max_issue_age.fromTo", { ageFrom: '71', ageTo: '75' }) },
            { value: '80', text: this.$t("products.travel.max_issue_age.fromTo", { ageFrom: '76', ageTo: '80' }) },
            { value: '85', text: this.$t("products.travel.max_issue_age.fromTo", { ageFrom: '81', ageTo: '85' }) },
            { value: '90', text: this.$t("products.travel.max_issue_age.fromTo", { ageFrom: '86', ageTo: '90' }) },
            { value: '100', text: this.$t("products.travel.max_issue_age.above", { age: '90' }) },
          ],
          
          tenlifeScoreValue: {
            value: this.$route.query?.tenlife_score ? this.$route.query?.tenlife_score : 'any',
            text: this.$t('products.travel.tenlife_score.any'),
          },
          tenlifeScoreOptions: [
            { value: 'any', text: this.$t('products.travel.tenlife_score.any') },
            { value: '8', text: '8+' },
            { value: '7', text: '7+' },
            { value: '6', text: '6+' },
          ],
        },
        perPage: 15,
        currentPage: 1,
        // homePlanScenarios: null,
        travelScenarios: null,
        alTrScenarios: null,
        insuranceCompanies: [],
        sortingData: {
          title: this.$t('products.sort'),
          sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'overall_score',
          text: ''
        },
          sortingOptions: [
            { value: 'overall_score', text: this.$t('products.travel.td_overall_score') },
            { value: 'adult_premium', text: this.$t('products.travel.td_sorting_adult_premium') },
            { value: 'medical_emergency_score', text: this.$t('products.travel.td_medical_emergency_score') },
            { value: 'accident_score', text: this.$t('products.travel.td_accident_score') },
            { value: 'inconv_score', text: this.$t('products.travel.td_inconv_score') },
            { value: 'property_score', text: this.$t('products.travel.td_property_score') },
          ],
        },
        showFilter: {
          planType: false,
          continent: false,
          travelRegion: false,
          selectDate: false,
          features: false,
          adultPremium: false,
          annualPremium: false,
          insurer: false,
          maxIssueAge: false,
          selectedCustomer: false,
          tenlifeScore: false,
        },
        // filterValuesToWatch: [],
        travelContinent: [], // SSR-safe default for travelContinent
      };
    },

    computed: {
      modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
      },
      mainQueryLoading() {
        return this.$apollo.queries.travelScenarios.loading || this.$apollo.queries.alTrScenarios.loading;
      },

      resultMessage() {
        if (this.mainQueryLoading) {
          return this.$t('products.travel.td_result').replace('$num', '{ }');
        } else {
          return this.$t('products.travel.td_result').replace('$num', this.rows);
        }
      },

      planTypeIsAnnual() {
        return this.filter.planTypeValue.value === 'annual';
      },

      displayProducts() {
        return this.sortedItem?.map((item) => {
          return {
            id: item.scenario_code,
            category: this.category,
            scenarioId: item.scenarioID,
            showFiveStarBadge: false,
            showTrending: false,
            showCTA: item.show_cta,
            productLink: this.buildProductLink(item),
            productName: item.plan_name,
            insuranceCompany: this.buildProductInsuranceCompany(item),
            tenlifeScore: this.buildProductTenlifeScore(item),
            features: this.buildProductFeatures(item),
            keyItems: this.buildProductKeyItems(item),
            mobileKeyItems: this.buildProductMobileKeyItems(item),
            compactKeyItems: this.buildProductCompactKeyItems(item),
            promotion: this.buildProductPromotion(item),
            mainButtonCTA: item.main_cta,
            showShortcut: item.shortcut,
            price: this.buildProductPrice(item),
          }
        });
      },

      rows() {
        if (this.simpleItems) {
          return this.simpleItems.length;
        }
        return 0;
      },

      sortedItem() {
        if (!this.simpleItems) return null;

        const premiumDay = this.planTypeIsAnnual ? 'premiumAnnual' : this.getPremiumDay();

        const getPremium = (item) => {
          return item.promotion_price ?? item.premium?.[premiumDay];
        };

        const sorters = {
          overall_score: (a, b) =>
            (Math.round(b.overall_score * 10) / 10) - (Math.round(a.overall_score * 10) / 10) ||
            getPremium(a) - getPremium(b) ||
            b.accident_score - a.accident_score ||
            b.personal_property_score - a.personal_property_score ||
            b.inconv_score - a.inconv_score ||
            b.medical_emergency_score - a.medical_emergency_score,

          medical_emergency_score: (a, b) =>
            b.medical_emergency_score - a.medical_emergency_score ||
            b.overall_score - a.overall_score ||
            getPremium(a) - getPremium(b) ||
            b.accident_score - a.accident_score ||
            b.personal_property_score - a.personal_property_score ||
            b.inconv_score - a.inconv_score,

          accident_score: (a, b) =>
            b.accident_score - a.accident_score ||
            b.overall_score - a.overall_score ||
            getPremium(a) - getPremium(b) ||
            b.personal_property_score - a.personal_property_score ||
            b.inconv_score - a.inconv_score ||
            b.medical_emergency_score - a.medical_emergency_score,

          inconv_score: (a, b) =>
            b.inconv_score - a.inconv_score ||
            b.overall_score - a.overall_score ||
            getPremium(a) - getPremium(b) ||
            b.accident_score - a.accident_score ||
            b.personal_property_score - a.personal_property_score ||
            b.medical_emergency_score - a.medical_emergency_score,

          adult_premium: (a, b) =>
            getPremium(a) - getPremium(b) ||
            b.overall_score - a.overall_score ||
            b.accident_score - a.accident_score ||
            b.personal_property_score - a.personal_property_score ||
            b.inconv_score - a.inconv_score ||
            b.medical_emergency_score - a.medical_emergency_score,

          property_score: (a, b) =>
            b.personal_property_score - a.personal_property_score ||
            b.overall_score - a.overall_score ||
            getPremium(a) - getPremium(b) ||
            b.accident_score - a.accident_score ||
            b.inconv_score - a.inconv_score ||
            b.medical_emergency_score - a.medical_emergency_score,

          annual_premium: (a, b) =>
            getPremium(a) - getPremium(b) ||
            b.overall_score - a.overall_score ||
            b.accident_score - a.accident_score ||
            b.personal_property_score - a.personal_property_score ||
            b.inconv_score - a.inconv_score ||
            b.medical_emergency_score - a.medical_emergency_score,
        };

        const sorter = sorters[this.sortingData?.sortValue?.value || 'overall_score'];
        return sorter ? [...this.simpleItems].sort(sorter) : this.simpleItems;
      },
      simpleItems() {
        const scenarioData = this.planTypeIsAnnual ? this.alTrScenarios?.data : this.travelScenarios?.data;

        if (!scenarioData) return null;

        // Filter out FWD insurer when start date is more than 90 days in the future
        const filterOutInsurer = (item) => {
          if (this.isStartDateMoreThan90DaysInFuture()) {
            const insurerCode = item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code;
            if (insurerCode === "FWD") {
              return false;
            }
          }
          return true;
        };

        if (this.planTypeIsAnnual) {
          return scenarioData
            .filter(item => {
              const isPromotionValid = this.validPromotion(item);
              const isAnnualPremiumValid = this.validPremium(item, 'premiumAnnual', isPromotionValid);
              return isAnnualPremiumValid !== false;
            })
            .map((item) => {
              const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;
              const promotions = this.getPromotions(item);
              const promotionDetails = this.getPromotionDetails(promotions, item);
              const filteredTranslations = this.getInsurerTranslations(item);

              return this.buildProductItem(item, promotionDetails, filteredTranslations, planName);
            });
        } else {
          const filteredTravelScenarios = this.filterScenariosByPriority(scenarioData)
          const premiumDay = this.getPremiumDay();
          if (premiumDay === null) return false;

          return filteredTravelScenarios
            .filter(filterOutInsurer)
            .filter(item => {
              const isPromotionValid = this.validPromotion(item);
              const isAdultPremiumValid = this.validPremium(item, premiumDay, isPromotionValid);
              return isAdultPremiumValid !== false;
            })
            .map((item) => {
              const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;
              const promotions = this.getPromotions(item);
              const promotionDetails = this.getPromotionDetails(promotions, item);
              const filteredTranslations = this.getInsurerTranslations(item);

              return this.buildProductItem(item, promotionDetails, filteredTranslations, planName);
            });
        }
      },
      slug() {
        return 'travel';
      },
      selectedSortingLogic() {
        return this.sortingData?.sortValue?.value
      },
    },

    created() {
      const watcher = [
        {
          filterValuePath: 'filter.planTypeValue',
          filterOptionsPath: 'filter.planTypeOptions',
          queryKey: 'type',
          ignoreFix: true,
          defaultValue: 'single',
        },
      ]
      // this.createFilterWatchers(watcher);
      this.fixFilterValues(watcher);
      this.setFilters(this.filter.planTypeValue.value);

      // Enable geoRegion watcher if initial plan type is single
      if (this.filter.planTypeValue.value === 'single') {
        this.$nextTick(() => {
          this.enableGeoRegionWatcher();
        });
      }
    },

    mounted() {
      const filterValuesToWatch = [
        {
          filterValuePath: 'filter.featureTypeValue',
          filterOptionsPath: 'filter.featureTypeOptions',
          queryKey: 'featuretype[]',
          defaultValue: [],
          ignoreFix: true,
          type: 'array',
        },
        {
          filterValuePath: 'sortingData.sortValue',
          filterOptionsPath: 'sortingData.sortingOptions',
          queryKey: 'sort',
          debounce: true,
          defaultValue: 'overall_score'
        },
        {
          filterValuePath: 'filter.insCompValue',
          filterOptionsPath: 'insuranceCompanies',
          queryKey: 'ins_comp[]',
          defaultValue: [],
          ignoreFix: true,
          type: 'array',
        },
        {
          filterValuePath: 'filter.datePeriod.value',
          filterOptionsPath: '',
          queryKey: 'date_period[]',
          defaultValue: [],
          ignoreFix: true,
          type: 'arrayDate',
        },
        {
          filterValuePath: 'filter.adultPremiumValue.value[0]',
          queryKey: 'adult_premium_from',
          defaultValue: 0,
          ignoreFix: true,
          type: 'slider',
        },
        {
          filterValuePath: 'filter.adultPremiumValue.value[1]',
          queryKey: 'adult_premium_to',
          defaultValue: 1500,
          ignoreFix: true,
          type: 'slider',
        },
        {
          filterValuePath: 'filter.travelContinentValue',
          filterOptionsPath: 'travelContinent',
          queryKey: 'continent',
          defaultValue: 'WW',
        },
        {
          filterValuePath: 'filter.annualPremiumValue.value[0]',
          queryKey: 'annual_premium_from',
          defaultValue: 0,
          ignoreFix: true,
          type: 'slider',
        },
        {
          filterValuePath: 'filter.annualPremiumValue.value[1]',
          queryKey: 'annual_premium_to',
          defaultValue: 5000,
          ignoreFix: true,
          type: 'slider',
        },
        {
          filterValuePath: 'filter.selectedCustomer',
          queryKey: 'selected_customer',
          defaultValue: false,
          ignoreFix: true,
          type: 'checkbox',
        },
        {
          filterValuePath: 'filter.maxIssueAgeValue',
          filterOptionsPath: 'filter.maxIssueAgeOptions',
          queryKey: 'max_issue_age',
          defaultValue: '70',
        },
        {
          filterValuePath: 'filter.tenlifeScoreValue',
          filterOptionsPath: 'filter.tenlifeScoreOptions',
          queryKey: 'tenlife_score',
          defaultValue: 'any',
        }
      ];
      this.createFilterWatchers(filterValuesToWatch);
      this.fixFilterValues(filterValuesToWatch);

      // Create geoRegionValue watcher separately and store reference
      this.createGeoRegionWatcher();

      const insurerFilterArrayValueToFix = {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
      };

      this.fixFilterArrayValueDueToQueryString(insurerFilterArrayValueToFix);

      const geoFilterArrayValueToFix = {
        filterValuePath: 'filter.geoRegionValue',
        filterOptionsPath: 'travelRegions',
        queryKey: 'geo[]',
      };

      this.fixFilterArrayValueDueToQueryString(geoFilterArrayValueToFix);

      const featureFilterArrayValueToFix = {
        filterValuePath: 'filter.featureTypeValue',
        filterOptionsPath: 'filter.featureTypeOptions',
        queryKey: 'featuretype[]',
      };
      // console.log(this.$route.query, 'query')
      this.fixFilterArrayValueDueToQueryString(featureFilterArrayValueToFix);

      const datePeriodFilterArrayValueToFix = {
        filterValuePath: 'filter.datePeriod.value',
        filterOptionsPath: '',
        queryKey: 'date_period[]',
      };
      // console.log(this.$route.query, 'query')
      this.fixFilterArrayValueDueToQueryString(datePeriodFilterArrayValueToFix);

      // Sync filter values after data is loaded
      this.$nextTick(() => {
        const initialSyncConfigs = [
          this.filterConfigs.travelContinent
        ];

        initialSyncConfigs.forEach(config => {
          this.syncFilterValueWithOptions(config);
        });
      });
    },

    watch: {
      '$route'(to) {
        if (to.path === '/products/travel' && Object.keys(to.query).length === 0) {
          this.setFilters('single');
        }
      },
      // '$route.query'(newValue, oldValue) {
      //   if (newValue && !newValue.type || newValue === null) this.setFilters('single');
      // },
      '$route.query.type'(newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          if (process.client) {
            this.setFilters(newValue);
          }
        }
      },
      // Watch for plan type changes to handle geoRegion watcher
      'filter.planTypeValue.value'(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue === 'single') {
            this.$nextTick(() => {
              this.enableGeoRegionWatcher();
            });
          } else if (newValue === 'annual') {
            this.disableGeoRegionWatcher();
          }
        }
      },
      // Watch for travelContinent changes to sync travelContinentValue
      travelContinent: {
        handler(newValue) {
          if (newValue && newValue.length > 0) {
            // Ensure travelContinentValue has a valid value from available options
            const currentValue = this.filter.travelContinentValue?.value;
            const validOption = newValue.find(option => option.value === currentValue);

            if (!validOption) {
              // If current value is not valid, set to first available option
              this.filter.travelContinentValue = {
                value: newValue[0].value,
                text: newValue[0].text
              };
            } else {
              // Update text to match current option
              this.filter.travelContinentValue.text = validOption.text;
            }
          }
        },
        immediate: true
      },
    },
    methods: {
      updateSortQuery() {
        // Debounce implementation
        if (this._updateSortQueryTimeout) clearTimeout(this._updateSortQueryTimeout);
        this._updateSortQueryTimeout = setTimeout(() => {
          const newSortValue = this.sortingData?.sortValue?.value;
          // Only update if the value is different
          if (this.$route.query.sort !== newSortValue) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            sort: newSortValue
          }
        });
          }
        }, 300);
      },
      resetFilters(planType) {
        // console.debug('resetFilter to: ', planType);

        if ( !this.showFilter ) return;

        // Reset type = slider query
        if (this.$route.query && planType === 'annual') {
          this.removeSingleQueryString('adult_premium_from');
          this.removeSingleQueryString('adult_premium_to');
        }
        if (this.$route.query && planType === 'single') {
          this.removeSingleQueryString('annual_premium_from');
          this.removeSingleQueryString('annual_premium_to');
        }

        // Reset product compare store
        this.$store.commit('productCompare/clearProducts');

        // Set planType-specific values
        const planTypeObj = this.filter.planTypeOptions.find(opt => opt.value === planType);
        if (planTypeObj) {
          this.filter.planTypeValue = { ...planTypeObj };
        } else {
          this.filter.planTypeValue = {
            value: planType,
            text: planType
          };
        }

        // Define filter configurations for reset and sync
        const filterConfigs = [
          {
            ...this.filterConfigs.geoRegion,
            defaultValue: [{
              value: 'japan',
              textKey: 'products.travel.td_default_geo',
              continent: "Asia"
            }]
          },
          this.filterConfigs.travelContinent
        ];

        // Reset and sync filter values
        this.resetAndSyncFilterValues(filterConfigs);

        // Reset all showFilter keys to false
        Object.keys(this.showFilter).forEach(key => {
          this.$set(this.showFilter, key, false);
        });
      },
      setFilters(planType) {
        // Disable geoRegion watcher before plan type changes
        this.disableGeoRegionWatcher();

        this.resetFilters(planType);

        if (planType === 'single') {
          this.showFilter.planType = true;
          this.showFilter.travelRegion = true;
          this.showFilter.selectDate = true;
          this.showFilter.features = true;
          this.showFilter.adultPremium = true;
          this.showFilter.insurer = true;
          this.showFilter.selectedCustomer = true;
          this.showFilter.maxIssueAge = true;
          this.showFilter.tenlifeScore = true;

          // Set sorting options for single
          this.sortingData.sortingOptions = [
            { value: 'overall_score', text: this.$t('products.travel.td_overall_score') },
            { value: 'adult_premium', text: this.$t('products.travel.td_sorting_adult_premium') },
            { value: 'medical_emergency_score', text: this.$t('products.travel.td_medical_emergency_score') },
            { value: 'accident_score', text: this.$t('products.travel.td_accident_score') },
            { value: 'inconv_score', text: this.$t('products.travel.td_inconv_score') },
            { value: 'property_score', text: this.$t('products.travel.td_property_score') },
          ];
          // Reset sorting value
          // this.sortingData.sortValue = { ...this.sortingData.sortingOptions[0] };
          
          // Enable geoRegion watcher for single plan
          this.$nextTick(() => {
            this.updateSortQuery();
            this.enableGeoRegionWatcher();
          });
        }
        if (planType === 'annual') {
          this.showFilter.planType = true;
          this.showFilter.continent = true;
          this.showFilter.selectDate = false;
          this.showFilter.features = true;
          this.showFilter.annualPremium = true;
          this.showFilter.insurer = true;
          this.showFilter.selectedCustomer = true;
          this.showFilter.maxIssueAge = true;
          this.showFilter.tenlifeScore = true;

          // Set sorting options for annual
          this.sortingData.sortingOptions = [
            { value: 'overall_score', text: this.$t('products.travel.td_overall_score') },
            { value: 'annual_premium', text: this.$t('products.travel.td_sorting_annual_premium') },
            { value: 'medical_emergency_score', text: this.$t('products.travel.td_medical_emergency_score') },
            { value: 'accident_score', text: this.$t('products.travel.td_accident_score') },
            { value: 'inconv_score', text: this.$t('products.travel.td_inconv_score') },
            { value: 'property_score', text: this.$t('products.travel.td_property_score') },
          ];
          // Reset sorting value
          // this.sortingData.sortValue = { ...this.sortingData.sortingOptions[0] };
          this.$nextTick(() => {
            this.updateSortQuery();
          });

          // geoRegion watcher remains disabled for annual plan
        }
      },
      getDate(date) {
        this.filter.datePeriod.value = date;
        const lastDate = moment(date[1]);
        const firstDate = moment(date[0]);

        if (date.length < 1) return;

        const availableDays = this.filter.datePeriod.availableDays;
        const diff = lastDate.diff(firstDate, 'days') + 1;
        // console.debug('datepicker diff', diff);
        if ( !availableDays ) {
          this.filter.datePeriod.range = diff;
          return diff;
        } else {
          if ( diff <= availableDays ) {
            this.filter.datePeriod.range = diff;
            return diff;
          } else {
            this.filter.datePeriod.range = -1;
            return -1;
          }
        }
      },
      isStartDateMoreThan90DaysInFuture() {
        if (!this.filter.datePeriod.value || this.filter.datePeriod.value.length === 0) {
          return false;
        }

        const firstDate = moment(this.filter.datePeriod.value[0]);
        const today = moment().startOf('day');
        const ninetyDaysFromNow = today.clone().add(90, 'days');

        return firstDate.isAfter(ninetyDaysFromNow);
      },
      parseDate(date) {
        const ydm = date.split('-');
        // console.log(ydm)
        return new Date(ydm[0], ydm[1], ydm[2]);
      },
      getScore(product) {
        return product.overall_score;
      },


      getDecoderCTA(item, promotionCTALink) {
        const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;
        const insurer = item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
        const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), insurer, planName);
        const showCTA = item.attributes.show_cta;
        const saleable = item.attributes.travel_plan.data.attributes.saleable;
        const productWebsite =
          item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.product_website;

        if (!showCTA) return null;

        if (saleable) {
          return {
            text: this.$t('products.purchase_now'),
            link:
              process.env.SALES_EXTERNAL_URL +
              '/' +
              (this.currentLocale === 'en' ? 'en' : 'tc') +
              '/purchase?id=' +
              item.attributes.scenario_code
          };
        } else if (promotionCTALink) {
          return {
            text: this.$t('products.purchase_now'),
            link: promotionCTALink,
          };
        } else if (productWebsite) {
          return {
            text: this.$t('products.product_website'),
            link: productWebsite,
            type: 'product-website',
          };
        } else {
          return {
            text: '',
            link: decoderCTAWhatsappLink,
          };
        }
      },

      getTooltipContentByKey(mKey) {
        return this.travelTooltips?.Travel?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
      },

      getPremiumDay(){
        let premiumDay;
        if ( this.filter.datePeriod.range < 1 ) return null;
        if (this.filter.datePeriod.range < 10) {
          premiumDay = 'premium' + '0' + this.filter.datePeriod.range;
        } else if (this.filter.datePeriod.range >= 10 && this.filter.datePeriod.range <= 31) {
          premiumDay = 'premium' + this.filter.datePeriod.range;
        } else if (this.filter.datePeriod.range > 31) {
          premiumDay = 'premium31';
        }
        return premiumDay;
      },

      filterScenariosByPriority(scenarios) {
        const priorities = ["-GBA-", "-CHINA-", "-ASIA-", "-AUS-", "-WWexUS-", "-WW-"];
        // use reversed priorities when continents contain both ASIA and other continents in order to prioritize -WWexUS- and -WW- products.
        const reversedPriorities = ["-WWexUS-", "-WW-", "-AUS-", "-ASIA-", "-CHINA-", "-GBA-"];
        const prioritiesWithUSA = ["-WW-"];
        // use prioritiesForAus when geo values only contains ASIA countries and Australia
        const prioritiesForAus = ["-AUS-", "-WWexUS-", "-WW-", "-ASIA-", "-GBA-", "-CHINA-" ];
        const planCodeMap = {};
        const filteredGeoValue = [];
        const filteredContinentArr = [];
        const otherContinentArr = [];
        let isOnlyContainAsia = false;
        let onlyContainAUS = false;
        let containAsiaAndAus = false;
        let containUSA = false;

        this.filter.geoRegionValue.forEach((geo) => {
          filteredGeoValue.push(geo.value);
          filteredContinentArr.push(geo.continent);
        })

        onlyContainAUS = filteredGeoValue.every((geoValue) => geoValue == 'australia');
        isOnlyContainAsia = filteredContinentArr.every((continent) => continent == 'Asia' );

        containUSA = filteredGeoValue.includes('united_states_of_america');

        filteredContinentArr.forEach((item) => {
          if (item !== 'Asia' && item !== 'Oceania') {
            otherContinentArr.push(item);
          }
        })

        if (otherContinentArr.length == 0) {
          if (filteredGeoValue.includes('australia')) {
            containAsiaAndAus = true;
          }
        }

        scenarios.forEach((item) => {
          // eslint-disable-next-line camelcase
          const {plan_code, scenario_code} = item.attributes;
          if (!planCodeMap[plan_code]) {
            planCodeMap[plan_code] = {priorityIndex: Infinity, item: null};
          }
          if (isOnlyContainAsia || onlyContainAUS) {
            for (let i = 0; i < priorities.length; i++) {
              if (scenario_code.includes(priorities[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          } else if (containAsiaAndAus) {
            for (let i = 0; i < prioritiesForAus.length; i++) {
              if (scenario_code.includes(prioritiesForAus[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          } else if (containUSA) {
            for (let i = 0; i < prioritiesWithUSA.length; i++) {
              if (scenario_code.includes(prioritiesWithUSA[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                }
                return;
              }
            }
          }
          else {
            for (let i = 0; i < reversedPriorities.length; i++) {
              if (scenario_code.includes(reversedPriorities[i])) {
                if (i < planCodeMap[plan_code].priorityIndex) {
                  if ( plan_code !== 'HSBC-AXA-TravelSurance-AsiaStandard' && plan_code !== 'HSBC-AXA-TravelSurance-AsiaBasic')  {
                    // console.debug('plan_code',plan_code)
                  planCodeMap[plan_code].priorityIndex = i;
                  planCodeMap[plan_code].item = item;
                  }
                }
                return;
              }
            }
          }
          // eslint-disable-next-line camelcase
          console.debug(`scenario_code "${scenario_code}" does not include the specified text.`);
        });

        const result = [];
        for (const planCode in planCodeMap) {
          if (planCodeMap[planCode].item) {
            result.push(planCodeMap[planCode].item);
          }
        }
        return result;
      },

      changeSelectedFeatures(value) {
        // console.log('value from FilterModal: ', value);
        this.filter.featureTypeValue = value;
      },

      getPromotions(item) {
        let promotions = null;
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.travel_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.travel_plan.data.attributes.product_promotions.data;
        }
        return promotions;
      },

      getPromotionDetails(promotions, item) {
        let promotion = null;
        let promotion_last_call = null;
        let promotionPrice = null;
        let decoderCTALink = '';
        let decoderCTAText = '';
        let hide = false;
        let noPopup = false;
        let mainCTA = this.getDecoderCTA(item, decoderCTALink);

        if (promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          promotion_last_call = this.checkPromotionLastCall(promotion);

          if (!promotion) {
            promotion = null;
          } else {
            if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink =
                promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
              decoderCTAText = this.$t('products.product_website');
              mainCTA = this.getDecoderCTA(item, decoderCTALink);
            }
            const discounts = promotion.attributes.DiscountPercentage;
            if (discounts) {
              const premium = this.planTypeIsAnnual ? 'premiumAnnual' : this.getPremiumDay();
              const originalPrice = item.attributes.travel_premiums.data[0]?.attributes[premium];
              if (discounts.Year1 !== 0)
                promotionPrice = originalPrice * (100 - discounts.Year1) / 100;
            }
            const translation = promotion.attributes.product_promotion_translations?.data[0];
            hide = translation?.attributes?.HideBanner;
            noPopup = translation?.attributes?.NoPopup ?? false;
          }
        }
        return {
          promotion,
          promotion_last_call,
          promotionPrice,
          decoderCTALink,
          decoderCTAText,
          hide,
          noPopup,
          mainCTA
        };
      },

      getInsurerTranslations(item) {
        const filteredTranslations = this.getFilteredTranslations(
          item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data
        );
        return filteredTranslations;
      },

      buildProductItem(item, promotionDetails, filteredTranslations, planName) {
        return {
          // plan
          plan_code: item.attributes.plan_code,
          scenario_code: item.attributes.scenario_code,
          scenarioID: item.id,
          plan_name: planName,
          accident_score: item.attributes.travel_plan.data.attributes.accident_score.toFixed(1),
          inconv_score: item.attributes.travel_plan.data.attributes.inconv_score.toFixed(1),
          medical_emergency_score: item.attributes.travel_plan.data.attributes.medical_emergency_score.toFixed(1),
          personal_property_score: item.attributes.travel_plan.data.attributes.property_score.toFixed(1),
          overall_score: item.attributes.travel_plan.data.attributes.overall_score.toFixed(1),
          saleable: item.attributes.travel_plan.data.attributes.saleable,
          show_cta: item.attributes.show_cta,

          // feature
          mobile_phone_protection: item.attributes.travel_plan.data.attributes.mobile_phone_protection,
          follow_up_physiotherapy: item.attributes.travel_plan.data.attributes.follow_up_physiotherapy,
          car_rental_excess: item.attributes.travel_plan.data.attributes.car_rental_excess,
          extreme_sports_medical: item.attributes.travel_plan.data.attributes.extreme_sports_medical,
          loss_of_travel_document: item.attributes.travel_plan.data.attributes.loss_of_travel_document,

          // insurer
          insurer_name_first:
            item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .insurance_company_translations.data[0].attributes.name,
          insurer_name_second: filteredTranslations[0].attributes.name,
          insurer_logo:
            item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
              .logo.data.attributes.url,
          insurer_code:
            item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,

          // premium
          premium: item.attributes.travel_premiums.data[0]?.attributes,
          decoder_cta_text: promotionDetails.decoderCTAText,
          decoder_cta_link: promotionDetails.decoderCTALink,

          product_promotion: promotionDetails.promotion,
          promotion_price: promotionDetails.promotionPrice,
          promotion_last_call: promotionDetails.promotion_last_call,

          hide: promotionDetails.hide,
          noPopup: promotionDetails.noPopup,

          main_cta: promotionDetails.mainCTA,
          shortcut: this.getProductShortcut(item.attributes),
        };
      },
      buildProductFeatures(item) {
        const features = [];
        if (item.mobile_phone_protection) {
          features.push({ text: this.$t('products.travel.td_mobile_protection'), type: 'mobile' });
        }
        if (item.follow_up_physiotherapy) {
          features.push({ text: this.$t('products.travel.td_physio'), type: 'physio' });
        }
        if (item.car_rental_excess) {
          features.push({ text: this.$t('products.travel.td_car_rental'), type: 'car_rental' });
        }
        if (item.extreme_sports_medical) {
          features.push({ text: this.$t('products.travel.td_extreme_sports'), type: 'extreme_sport' });
        }
        if (item.loss_of_travel_document) {
          features.push({ text: this.$t('products.travel.td_loss_travel_doc'), type: 'loss_travel_doc' });
        }
        return features;
      },

      buildProductKeyItems(item) {
        return [
          {
            value: this.$formatScore(item.medical_emergency_score) + ' / 10',
            key: this.$t('products.travel.td_medical_emergency_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_medicalEmergencyScore"),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.$formatScore(item.accident_score) + ' / 10',
            key: this.$t('products.travel.td_accident_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_accidentScore"),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.$formatScore(item.inconv_score) + ' / 10',
            key: this.$t('products.travel.td_inconv_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_inconvenienceScore"),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.$formatScore(item.personal_property_score) + ' / 10',
            key: this.$t('products.travel.td_property_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_propertyScore"),
            symbolValue: '',
            originalValue: '',
          },
        ];
      },

      buildProductMobileKeyItems(item) {
        return [
          {
            value: this.$formatScore(item.medical_emergency_score) + ' / 10',
            key: this.$t('products.travel.td_medical_emergency_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_medicalEmergencyScore"),
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
          {
            value: this.$formatScore(item.accident_score) + ' / 10',
            key: this.$t('products.travel.td_accident_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_accidentScore"),
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
          {
            value: this.$formatScore(item.inconv_score) + ' / 10',
            key: this.$t('products.travel.td_inconv_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_inconvenienceScore"),
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
          {
            value: this.$formatScore(item.personal_property_score) + ' / 10',
            key: this.$t('products.travel.td_property_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey("tr_propertyScore"),
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
        ]
      },

      buildProductCompactKeyItems(item) {
        // Add your compact key items logic here if needed
        return [];
      },

      buildProductPromotion(item) {
        return {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          hide: item.hide,
          noPopup: item.noPopup,
          lastCall: item.promotion_last_call
        };
      },

      // buildProductPrice(item) {
      //   let premiumDay = this.getPremiumDay();
      //   return {
      //     originalPrice: item.promotion_price ?
      //       item?.premium?.[premiumDay] ? this.$formatPrice(item?.premium?.[premiumDay], 'travel') : ''
      //       : '',
      //     discountPrice:
      //       item.promotion_price ? this.$formatPrice(item?.promotion_price, 'travel') :
      //       item?.premium?.[premiumDay] ? this.$formatPrice(item?.premium?.[premiumDay], 'travel') : '',
      //     prefix: "HKD",
      //     postfix: '',
      //     subText: this.$t('products.travel.td_adult_premium'),
      //     toolTipHtml: this.getTooltipContentByKey("tr_adult"),
      //   };
      // },
      buildProductPrice(item) {
        // Handle premium field based on plan type
        let premiumDay = null;
        let originalPrice = '';
        let discountPrice = '';

        if (this.planTypeIsAnnual) {
          // Annual plan: use premiumAnnual or promotion_price
          originalPrice = item.promotion_price
            ? (item.premium?.premiumAnnual ? this.$formatPrice(item.premium.premiumAnnual, 'travel') : '')
            : '';
          discountPrice = item.promotion_price
            ? this.$formatPrice(item.promotion_price, 'travel')
            : (item.premium?.premiumAnnual ? this.$formatPrice(item.premium.premiumAnnual, 'travel') : '');
        } else {
          // Single plan: use premiumDay
          premiumDay = this.planTypeIsAnnual ? 'premiumAnnual' : this.getPremiumDay();
          originalPrice = item.promotion_price
            ? (item.premium?.[premiumDay] ? this.$formatPrice(item.premium[premiumDay], 'travel') : '')
            : '';
          discountPrice = item.promotion_price
            ? this.$formatPrice(item.promotion_price, 'travel')
            : (item.premium?.[premiumDay] ? this.$formatPrice(item.premium[premiumDay], 'travel') : '');
        }

        return {
          originalPrice,
          discountPrice,
          prefix: "HKD",
          postfix: '',
          subText: this.planTypeIsAnnual ? this.$t('products.travel.td_annual_premium') : this.$t('products.travel.td_adult_premium'),
          toolTipHtml: this.planTypeIsAnnual ? this.getTooltipContentByKey("tr_annual") : this.getTooltipContentByKey("tr_adult"),
        };
      },

      buildProductInsuranceCompany(item) {
        return {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo,
          logoAlt: item.insurer_name_first,
        };
      },

      buildProductTenlifeScore(item) {
        return {
          score: parseFloat(this.getScore(item)),
          description: this.$t('products.travel.td_overall_score'),
          toolTipHtml: this.getTooltipContentByKey("tr_overallScore"),
        };
      },

      buildProductLink(item) {
        if ( this.planTypeIsAnnual ) {
          return this.$extendPath(
            this.$route.path,
            '/' + item.scenario_code
          );
        }
        return this.$extendPath(
          this.$route.path,
          '/' + item.scenario_code + '?' + 'duration=' + this.filter.datePeriod.range
        );
      },
      validPremium(item, premiumItem, validPromotion) {
        const premium = premiumItem === 'premiumAnnual' ? item.attributes.travel_premiums?.data[0]?.attributes?.premiumAnnual : item.attributes.travel_premiums?.data[0]?.attributes[premiumItem];
        const range = this.planTypeIsAnnual
          ? this.filter.annualPremiumValue.value
          : this.filter.adultPremiumValue.value;

        const itemPremium = validPromotion !== undefined ? validPromotion : premium || null;

        if (itemPremium === -1) {
          return false;
        } else if (itemPremium < range[0] || itemPremium > range[1]) {
          return false;
        }
        return true;
      },

      validPromotion(item) {
        let promotions = null;
        let promotion = null;
        let promotionPrice = null;

        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.travel_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.travel_plan.data.attributes.product_promotions.data;
        }

        if(promotions === null) return undefined;
        promotion = this.checkPromotionValid(promotions);

        if (promotion === null) return undefined;

        const discounts = promotion.attributes.DiscountPercentage;
        if (discounts) {
          // calculate promotion price and avg premium
          const premiumDay = this.getPremiumDay();

          const originalPrice = item.attributes.travel_premiums.data[0]?.attributes[premiumDay];
          if(discounts.Year1 !== 0) promotionPrice = originalPrice * (100 - discounts.Year1) / 100;

          return promotionPrice;
        }
      },
      handleMobilePlanType(data) {
        this.filter.planTypeValue = data;
        this.$store.commit('modal/setDisplayMobileFilter', {isOpen: false});
      },
      filterSelectedCustomer(data) {
        const selectedCustomer = this.filter.selectedCustomer;
        if (selectedCustomer) {
          return data.filter(item => {
            return item.attributes.selected_customer && item.attributes.selected_customer === selectedCustomer;
          });
        }
        return data;
      },
      filterMaxIssueAge(data) {
        // Filter: max_issue_age
        if (this.filter.maxIssueAgeValue && this.filter.maxIssueAgeValue.value) {
          return data.filter(item => {
            const maxIssueAge = item.attributes.travel_plan.data.attributes.max_issue_age;
            // If max_issue_age is not defined, include the item
            if (maxIssueAge === undefined || maxIssueAge === null) return true;
            // If max_issue_age is -1, always include
            if (Number(maxIssueAge) === -1) return true;
            // Only include if filter value >= max_issue_age
            return Number(this.filter.maxIssueAgeValue.value) >= Number(maxIssueAge);
          });
        }
        return data;
      },
      onResetFilterPosition() {
        this.$refs.filterModalMobile && this.$refs.filterModalMobile.resetFilterPosition();
      },
      setActive(filter) {
        // set the active filter to top, prevent overlap other filters
        this.activeFilter = filter;
      },
      createGeoRegionWatcher() {
        const geoRegionConfig = {
          filterValuePath: 'filter.geoRegionValue',
          filterOptionsPath: 'travelRegions',
          queryKey: 'geo[]',
          defaultValue: ['japan'],
          ignoreFix: true,
          type: 'array',
        };

        // Create the watchers and store references
        this.geoRegionWatchers = {
          filterWatcher: this.$watch(
            () => this.$_.get(this, geoRegionConfig.filterValuePath),
            (newValue, oldValue) => {
              if (this.$_.isEqual(newValue, oldValue)) return;
              if (newValue === undefined || newValue?.length === 0) {
                // special case for geo[] = 0
                if (geoRegionConfig.queryKey === 'geo[]') {
                  this.extendQueryString({ [geoRegionConfig.queryKey]: '0' });
                  return;
                }
                this.removeSingleQueryString(geoRegionConfig.queryKey);
              } else {
                this.extendQueryString({ [geoRegionConfig.queryKey]: newValue?.map((element) => element.value).sort() });
              }
            },
            { deep: true }
          ),
          queryWatcher: this.$watch(
            () => this.$route.query[geoRegionConfig.queryKey],
            (newValue) => {
              const mValue = newValue === undefined || newValue?.length === 0 ? [] : newValue;
              const options = this.$_.get(this, geoRegionConfig.filterOptionsPath);
              const foundValues = mValue
                ? options
                    .filter((ins) => mValue.includes(ins.value))
                    .map((x) => ({
                      value: x.value,
                      text: x.text,
                      continent: x?.continent,
                    }))
                : [];
              this.$_.set(this, geoRegionConfig.filterValuePath, foundValues);
            }
          )
        };
      },

      enableGeoRegionWatcher() {
        if (!this.geoRegionWatchers) {
          this.createGeoRegionWatcher();
        }
      },

      disableGeoRegionWatcher() {
        if (this.geoRegionWatchers) {
          // Unwatch to disable the watchers
          if (this.geoRegionWatchers.filterWatcher) {
            this.geoRegionWatchers.filterWatcher();
          }
          if (this.geoRegionWatchers.queryWatcher) {
            this.geoRegionWatchers.queryWatcher();
          }
          this.geoRegionWatchers = null;
        }
      },

      syncTravelContinentValue() {
        if (this.travelContinent && this.travelContinent.length > 0) {
          const currentValue = this.filter.travelContinentValue?.value;
          const validOption = this.travelContinent.find(option => option.value === currentValue);

          if (!validOption) {
            // If current value is not valid, set to first available option
            this.filter.travelContinentValue = {
              value: this.travelContinent[0].value,
              text: this.travelContinent[0].text
            };
          } else {
            // Update text to match current option
            this.filter.travelContinentValue.text = validOption.text;
          }
        }
      },

      // Generic method to reset filter values to defaults
      resetFilterValueToDefault(filterConfig) {
        const { path, defaultValue, queryKey, defaultTextKey } = filterConfig;

        if (Array.isArray(defaultValue)) {
          // Handle array values (like geoRegionValue)
          const processedValue = defaultValue.map(item => {
            if (item.textKey) {
              return {
                ...item,
                text: this.$t(item.textKey)
              };
            }
            return item;
          });
          this.$_.set(this, path, processedValue);
        } else {
          // Handle object values (like travelContinentValue)
          this.$_.set(this, path, {
            value: this.$route.query?.[queryKey] || defaultValue,
            text: defaultTextKey ? this.$t(defaultTextKey) : defaultValue
          });
        }
      },

      // Generic method to sync filter values with available options
      syncFilterValueWithOptions(filterConfig) {
        const { path, optionsPath, syncMethod } = filterConfig;

        if (syncMethod) {
          // Use custom sync method if provided
          this[syncMethod]();
        } else {
          // Generic sync logic
          const options = this.$_.get(this, optionsPath);
          const currentValue = this.$_.get(this, path);

          if (options && options.length > 0) {
            if (Array.isArray(currentValue)) {
              // Handle array values
              const validValues = currentValue.filter(val =>
                options.some(option => option.value === val.value)
              );
              if (validValues.length === 0) {
                this.$_.set(this, path, [options[0]]);
              }
            } else if (currentValue && typeof currentValue === 'object') {
              // Handle object values
              const validOption = options.find(option => option.value === currentValue.value);
              if (!validOption) {
                this.$_.set(this, path, {
                  value: options[0].value,
                  text: options[0].text
                });
              } else {
                this.$_.set(this, path + '.text', validOption.text);
              }
            }
          }
        }
      },

      // Generic method to reset and sync multiple filter values
      resetAndSyncFilterValues(filterConfigs) {
        filterConfigs.forEach(config => {
          this.resetFilterValueToDefault(config);
        });

        // Sync after reset
        this.$nextTick(() => {
          filterConfigs.forEach(config => {
            this.syncFilterValueWithOptions(config);
          });
        });
      }
    },
    components: {
      QuickGuideWrapper
    },
    beforeDestroy() {
      // Clean up geoRegion watchers
      this.disableGeoRegionWatcher();
    },
  };
  